import JDILogin from '@/app/login/index.login';

/**
 登录后执行回调函数，如未登录，则自动打开登录框，登录后继续执行回调函数
 用法:
 callAfterLogin(() => {
   // 函数内部编写跳转订单页 或者 其他需要登录的页面或者必须依赖登录后的操作
 }

 //
*/
export enum LoginCallBackType {
  dpCouponTaken = '0', // 商详手动领券
  dpCouponAutoTaken = '1', // 商详 buy now 自动领券
  dpBuyNow = '3', // 商详buy now 未登录回调
}
// 登录页面跳转执行页面级回调
export async function callAfterLoginByUrl(
  callbackFunc: () => Promise<any>,
  props: {
    type: string;
  },
) {
  const userInfo = await JDILogin.getInstance().getUserInfo();
  if (userInfo.isLoggedIn) {
    typeof callbackFunc === 'function' && callbackFunc();
  } else {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    params.set('isNext', 'true');
    params.set('callbackOptType', props.type);
    url.search = params.toString();
    JDILogin.getInstance().jumpToLoginPage({
      returnUrl: url.toString(),
    });
  }
}

export default async function callAfterLogin(callbackFunc: () => void) {
  const userInfo = await JDILogin.getInstance().getUserInfo();
  if (userInfo.isLoggedIn) {
    typeof callbackFunc === 'function' && callbackFunc();
  } else {
    JDILogin.getInstance().openLoginDialog();
  }
}
